import { Component, Input, Output, EventEmitter, effect, model } from '@angular/core';
import { FormField, FormFieldTypes } from 'src/app/shared/forms/abstract-form-field.directive';
import { FormContainerVM, FormFieldValue } from 'src/app/shared/forms/form-vm-container.directive';

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss']
})
export class InputTextComponent extends FormField<string>{
  readonly type: FormFieldTypes = 'text';
  
  get value() {
    return this.text()
  }

  override updateModel(formVM: FormContainerVM, value: FormFieldValue): FormContainerVM {
    throw new Error('Method not implemented.');
  }

  inputInformations: string = '';
  @Input() placeholder: string = '';
  @Input() width: string = '';
  @Input() height: string = '';
  @Input() searchField: boolean = false;
  text =  model<string>();
  @Input() initValue: string ='';

  @Output() getCharactersInput = new EventEmitter();
 

  applyDesign() {

    return { width: this.width, height: this.height };
  }

  getChanges(event: any) {
    this.inputInformations = event.target.value;
    this.model = this.inputInformations
    this.getCharactersInput.emit(this.inputInformations);
  }
}
